import { fetchAllPromisedData } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod"
import { endpoint } from "../../../../views/pages/manage/common/constant"
import { dropdownMapping } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod"

export const getDropdown= async()=>{
  const res=  await Promise.all([
    fetchAllPromisedData(endpoint.getAllRegularCourseId),
    dropdownMapping(endpoint.term.getAllActive,"termDispValue","termDispValue"),
    dropdownMapping(endpoint.businessArea.getAllActiveV2,"businessAreaDispValue","businessAreaDispValue"),
    dropdownMapping(`${endpoint.courseCatelogHeader.getByGroupCodeAndCompanyCodeAndSecurity}/?groupCode=1&companyCode=1&security=true`,'courseId','courseId'),
])
return {
    regularCourseId: res[0].map((item)=>({label:item, value:item})),
    regTerm: res[1],
    bu: res[2],
    sdCourseId: res[3],
}
}